import {HintsGroup} from "../Hint";
import { i18n } from 'src/boot/i18n';
// import {horizontalScrollInParentTo} from 'src/utils/helpers'

const tours = [
  // Disable all Home Tours
  // {
  //   name: "HomeTour",
  //   steps: [
  //     {
  //       title: "Découverte de la page d'accueil",
  //       intro: "Voici la carte d'un morceau.",
  //       element: ".home-tour__play-card",
  //       onStepEnter: () => {
  //         horizontalScrollInParentTo('home-tour__play-card');
  //       }
  //     },
  //     {
  //       title: "Découverte de la page d'accueil",
  //       intro: "Ce bouton permet de le voir joué par Tokatab et de le travailler !",
  //       element: ".home-tour__play-card .home-hints__play-card"
  //     },
  //     {
  //       title: "Découverte de la page d'accueil",
  //       intro: "Cliquer sur le morceau permet de voir une page contenant ses infos musicales.",
  //       element: ".home-tour__play-card"
  //     },
  //     {
  //       title: "Découverte de la page d'accueil",
  //       intro: "Ce chiffre est votre score de maitrise. Plus vous progresserez en travaillant des morceaux et des exercices et plus il grandira sur des morceaux pas encore abordés mais contenant les techniques de piano que vous aurez apprise.",
  //       element: ".home-tour__play-card .home-tour__score-card",
  //     },
  //     {
  //       title: "Découverte de la page d'accueil",
  //       intro: "Tokatab propose des morceaux dans 5 niveaux : Novice / Débutant / Intermédiaire / Avancé / Pro.",
  //       element: ".home-tour__play-card .home-tour__difficulty"
  //     }
  //   ]
  // }
] as any[];

const hints = [
  // {
  //   name: "HomeHintsDoing",
  //   hints: [
  //     {
  //       hint: "Cliquer sur ce bouton permet de continuer un cours que vous avez commencé.",
  //       hintPosition: "top-right",
  //       element: ".home-hints__play-doing"
  //     }
  //   ]
  // },
  {
    name: "HomeHintsChallenge",
    hints: [
      {
        hint: i18n.t('onboardingHomeData.hints.challenge'),
        hintPosition: "top-right",
        element: ".home-hints__challenges"
      }
    ]
  },
  {
    name: "HomeHintsProfil",
    hints: [
      {
        hint: i18n.t('onboardingHomeData.hints.profil'),
        element: ".home-hints__profil",
        hintPosition: "top-right"
      }
    ]
  },
  {
    name: "RepertoireHintsFilterVersion",
    hints: [
      {
        hint: i18n.t('onboardingHomeData.hints.filterVersion'),
        element: ".repertoire-hints__inspired",
        hintPosition: "top-middle"
      }
    ]
  },
  {
    name: "RepertoireHintsSortBy",
    hints: [
      {
        hint: i18n.t('onboardingHomeData.hints.sortBy'),
        element: ".repertoire-hints__sort",
        hintPosition: "bottom-right"
      }
    ]
  }
] as HintsGroup[];

export default {tours, hints};
